import { IonCheckbox, IonItem, IonLabel } from '@ionic/react';
import { ComponentProps, PropsWithChildren } from 'react';
import { Control, Controller, FieldError, FieldPath, FieldValues } from 'react-hook-form';

import styles from '@components/fields/Checkbox.module.css';
import Error from '@components/fields/Error';
import RequiredFieldIndicator from '@components/fields/RequiredFieldIndicator';
import BodyCopy from '@components/typography/BodyCopy';

type Props<FormData extends FieldValues> = ComponentProps<typeof IonCheckbox> &
  PropsWithChildren<{
    control: Control<FormData>;
    error: FieldError | undefined;
    name: FieldPath<FormData>;
    required?: boolean;
  }>;

const Checkbox = <FormData extends FieldValues>({
  children,
  control,
  error,
  name,
  required = false,
  ...inputProps
}: Props<FormData>) => (
  <>
    <IonItem className={styles.wrapperItem} lines="none">
      <Controller
        control={control}
        name={name}
        render={({ field: { name, onBlur, onChange, value } }) => (
          <IonCheckbox
            checked={!!value}
            className={styles.checkBox}
            data-test="checkbox"
            name={name}
            onIonBlur={onBlur}
            onIonChange={e => {
              onChange(!e.detail.value);
            }}
            onKeyUp={e => {
              if (e.code === 'Enter') {
                e.currentTarget.click();
              }
            }}
            slot="start"
            tabIndex={0}
            value={value as string}
            {...inputProps}
          />
        )}
      />
      <IonLabel className="ion-text-wrap ion-no-margin">
        <BodyCopy>
          {children}
          {required && <RequiredFieldIndicator />}
        </BodyCopy>
      </IonLabel>
    </IonItem>
    {error && (
      <div>
        {error && (
          <div>
            <Error error={error} />
          </div>
        )}
      </div>
    )}
  </>
);

export default Checkbox;
